import { chainReducers, createApiReducer, INITIAL_API_STATE } from 'services/api';
import { transformTenant } from '../transformation';
import { TenantsActionTypes } from './actions';



const fetchTenantsReducer = createApiReducer(
  [
    TenantsActionTypes.FETCH_TENANTS_START,
    TenantsActionTypes.FETCH_TENANTS_SUCCESS,
    TenantsActionTypes.FETCH_TENANTS_FAILURE,
  ],
  transformTenant,
  data => data,
);

const tenantChainedReducers = chainReducers(
  INITIAL_API_STATE,
  fetchTenantsReducer
);

export default tenantChainedReducers;



